var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dashboard-block" }, [
    _c("h2", [_vm._v("Payment Details")]),
    _vm._v(" "),
    _c("ul", { staticClass: "item-detail item-detail-simple" }, [
      _c(
        "li",
        [
          _vm.userManagesOwnPayment
            ? _c(
                "router-link",
                {
                  attrs: {
                    to: {
                      name: `${_vm.$route.name}.payment-details`,
                      params: { id: _vm.user.id },
                    },
                    "active-class": "",
                  },
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _vm.userIsTalent
                      ? _c("div", { staticClass: "col-xs-8" }, [
                          _c("h3", { staticClass: "has-sub" }, [
                            _vm._v("My Payment Details"),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "sub-text" }, [
                            _vm._v(
                              "Let us know how and where you want to be paid."
                            ),
                          ]),
                        ])
                      : _vm.userIsManager
                      ? _c("div", { staticClass: "col-xs-8" }, [
                          _c("h3", { staticClass: "has-sub" }, [
                            _vm._v("Default Payment Details"),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "sub-text" }, [
                            _vm._v(
                              "Set default payment details for all " +
                                _vm._s(_vm.$starLabelPlural) +
                                " under your management.."
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-4" }, [
                      _c("div", { staticClass: "actions pull-right" }, [
                        _c("span", { staticClass: "btn btn-info" }, [
                          _c("i", { staticClass: "fa fa-pencil" }),
                        ]),
                      ]),
                    ]),
                  ]),
                ]
              )
            : _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-8" }, [
                  !_vm.userManagesOwnPayment
                    ? _c("h3", { staticClass: "sub-text" }, [
                        _vm._v(
                          "Your payments are handled through your manager"
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }